import { render } from "./TabPanels.vue?vue&type=template&id=7e90e2d3&scoped=true"
import script from "./TabPanels.vue?vue&type=script&lang=js"
export * from "./TabPanels.vue?vue&type=script&lang=js"

import "./TabPanels.vue?vue&type=style&index=0&id=7e90e2d3&scoped=true&lang=css"

import exportComponent from "E:\\backup\\Vue\\NK\\Register_studen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e90e2d3"]])

export default __exports__